import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllSkillQuiz,
  saveFlnSkillQuiz,
  updateFlnSkillQuiz,
  deleteFlnSkillQuiz,
} from "./FlnActivity.Thunk";

const initialState = {
  data: [],
  skill: [],
  loading: false,
  status: "",
  message: "",
  language: "",
  usertype: "",
  disable_content_button: true,
  contentData: [],
  topicId: "",
  topicName: "",
  option: "",
};

const FlnActivitySlice = createSlice({
  name: "FlnActivitySlice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    setSkill: (state, action) => {
      state.skill = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
    setContentData: (state, action) => {
      state.contentData = action.payload;
    },
    setTopicId: (state, action) => {
      state.topicId = action.payload;
    },
    setTopicName: (state, action) => {
      state.topicName = action.payload;
    },
    setOption: (state, action) => {
      state.option = action.payload;
    },
  },
  extraReducers: {
    [getAllSkillQuiz.pending]: (state, action) => {
      state.topic = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getAllSkillQuiz.fulfilled]: (state, action) => {
      state.topic = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getAllSkillQuiz.rejected]: (state, action) => {
      state.topic = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [saveFlnSkillQuiz.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [saveFlnSkillQuiz.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [saveFlnSkillQuiz.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateFlnSkillQuiz.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateFlnSkillQuiz.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateFlnSkillQuiz.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [deleteFlnSkillQuiz.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [deleteFlnSkillQuiz.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [deleteFlnSkillQuiz.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  language_change,
  usertype_change,
  setSkill,
  setContentData,
  setTopicId,
  setTopicName,
  setOption,
} = FlnActivitySlice.actions;

export default FlnActivitySlice.reducer;
